export default "__VITE_ASSET__DM6pfl47__"